// extracted by mini-css-extract-plugin
export var callCard = "_nq-0";
export var callMessageButton = "_nq-1";
export var helpIcon = "_nq-3";
export var helpIconContainer = "_nq-4";
export var verticalDivider = "_nq-2";